import { Box, IconButton, MenuItem, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Fragment, useContext, useState } from 'react';
import { Button, Card, CardHeader, Col, Container, Input, Row, Table } from 'reactstrap';
import DataNotFound from '../../DataNoteFound/DataNotFound';
import Breadcrumbs from '../../layout/breadcrumb';
import TableSkeleton from '../../loader/TableSkeleton';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { MuiTabelStyle } from '../../utils/helper';
import AccommodationContext from '../../context/AccommodationContext/AccommodationContext';
import moment from 'moment';
import { useNavigate } from 'react-router';
import { classes } from '../../data/layouts';
import { Download, Info, Link2 } from 'react-feather';
import { VerifiedUser } from '@material-ui/icons';
import { VerifiedPayment, Accommodation_Export } from '../../api/AccommodationApi/AccommodationApi';
import { toast, Zoom } from 'react-toastify';
import { DatePicker } from 'antd';
import GenerateBookingLinkModal from './GenerateBookingLinkModal';
const { RangePicker } = DatePicker;
const AccommodationBookingList = (props) => {
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const history = useNavigate();
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === 'compact-wrapper');
  const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();
  const { sorting, setPage, setPageSize, pageSize, page, record } = props;
  const { formvalue, filter, setFilter, startDate, setStartDate, endDate, setEndDate, dateField, setDateField, dateRange, setDateRange } = useContext(AccommodationContext);
  const { responseLoader, setLoaderShow } = useContext(OrganizationContext);
  const ClearAllhandler = () => {
    setFilter({
      mobile: '',
      razorpay_order_id: '',
      checkInDateTime: '',
      checkOutDateTime: '',
      createdAt: ''
    });
    setStartDate('');
    setEndDate('');
    setDateField('');
    setDateRange(null);
  };

  const redirectDetailPage = (bookingId) => {
    const url = `${process.env.PUBLIC_URL}/AccommodationDetail/accommodation/${bookingId}/${layout}`;
    history(url);
  };
  const verifyPayment = async (bookingId) => {
    setLoaderShow(true);
    try {
      const { data } = await VerifiedPayment({ booking_id: bookingId });
      console.log('Payment Verified:', data);
      if (data.status === 200) {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
        props.getData();
      } else {
        toast.error(data.message, {
          autoClose: 1000,
          transition: Zoom
        });
      }
    } catch (error) {
      console.error('Verify Payment Error:', error);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setLoaderShow(false);
    }
  };
  const handleRangeChange = (values) => {
    setDateRange(values);
    if (values) {
      setStartDate(moment(values[0]?.$d).format('YYYY-MM-DD'));
      setEndDate(moment(values[1]?.$d).format('YYYY-MM-DD'));
    } else {
      setStartDate('');
      setEndDate('');
    }
  };
  const handleFilterChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value
    }));
  };
  const handleDownloadCSV = async () => {
    try {
      const activeFilters = Object.fromEntries(Object.entries(filter).filter(([_, v]) => v));
      let paramObj = {
        search: activeFilters
      };
      if (startDate) {
        paramObj['search'] = { ...paramObj.search, start: startDate };
      }
      if (endDate) {
        paramObj['search'] = { ...paramObj.search, end: endDate };
      }
      if (dateField) {
        paramObj['search'] = { ...paramObj.search, dateField };
      }

      const response = await Accommodation_Export(paramObj);
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'room_booking_report.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Error exporting file', {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  // -------------------------------
  // COLUMNS BASED ON NEW API
  // -------------------------------
  const defaultColumns = [
    {
      flex: 0.18,
      minWidth: 200,
      field: 'name',
      headerName: 'Guest Name',
      renderCell: (params) =>
        (
          <span style={{ cursor: 'pointer' }} onClick={() => redirectDetailPage(params.row.bookingId)}>
            {params.row.personDetail?.name}
          </span>
        ) ?? '--'
    },
    {
      flex: 0.18,
      minWidth: 150,
      field: 'mobile',
      headerName: 'Mobile Number',
      renderCell: (params) =>
        (
          <span style={{ cursor: 'pointer' }} onClick={() => redirectDetailPage(params.row.bookingId)}>
            {params.row.personDetail?.mobile}
          </span>
        ) ?? '--'
    },
    {
      flex: 0.15,
      minWidth: 130,
      field: 'occupation',
      headerName: 'Occupation',
      renderCell: (params) => params.row.occupation ?? '--'
    },
    {
      flex: 0.15,
      minWidth: 160,
      field: 'checkInDateTime',
      headerName: 'Check-In Date',
      renderCell: (params) =>
        params.row.checkInDateTime ? moment.utc(params.row.checkInDateTime).local().format('YYYY-MM-DD HH:mm:ss') : '--'
    },
    {
      flex: 0.15,
      minWidth: 160,
      field: 'checkOutDateTime',
      headerName: 'Check-Out Date',
      renderCell: (params) =>
        params.row.checkOutDateTime
          ? moment.utc(params.row.checkOutDateTime).local().format('YYYY-MM-DD HH:mm:ss')
          : '--'
    },
    {
      flex: 0.12,
      minWidth: 130,
      field: 'refName',
      headerName: 'Reference Name',
      renderCell: (params) => params.row.refName ?? '--'
    },
    {
      flex: 0.12,
      minWidth: 100,
      field: 'refMobileNo',
      headerName: 'Reference Mobile',
      renderCell: (params) => params.row.refMobileNo || '--'
    },
    {
      flex: 0.1,
      minWidth: 50,
      field: 'noOfPerson',
      headerName: 'No. of Persons',
      renderCell: (params) => params.row.noOfPerson ?? '--'
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'amount',
      headerName: 'Amount',
      renderCell: (params) => params.row.amount ?? '--'
    },
    {
      flex: 0.2,
      minWidth: 180,
      field: 'razorpay_order_id',
      headerName: 'Order ID',
      renderCell: (params) => params.row.razorpay_order_id ?? '--'
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'status',
      headerName: 'Status',
      renderCell: (params) => params.row.status ?? '--'
    },
    {
      flex: 0.15,
      minWidth: 150,
      field: 'createdAt',
      headerName: 'Booking Date',
      renderCell: (params) =>
        params.row.createdAt ? moment.utc(params.row.createdAt).local().format('YYYY-MM-DD HH:mm:ss') : '--'
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      minWidth: 120,
      renderCell: (params) => (
        <div className="d-flex p-0 m-0">
          <MenuItem onClick={() => redirectDetailPage(params.row.bookingId)}>
            <Info style={{ color: 'green' }} />
          </MenuItem>
          <MenuItem onClick={() => verifyPayment(params.row.bookingId)}>
            <VerifiedUser style={{ color: 'green' }} />
          </MenuItem>
        </div>
      )
    }
  ];

  return (
    <Fragment>
      <Breadcrumbs parent="Accommodation Booking" />

      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}
              >
                <h3 className="m-0">Accommodation Booking</h3>
                <Button
                  color="primary"
                  onClick={() => setOpenInviteModal(true)}
                  style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <Link2 size={16} /> Generate Booking Link
                </Button>
              </CardHeader>

              <Table>
                <thead>
                  <tr>
                    <th>
                      <Row>
                        <Col md="2 mb-2">
                          <Input
                            type="number"
                            className="form-control"
                            placeholder="Search Mobile..."
                            value={filter.mobile}
                            onChange={(e) => handleFilterChange('mobile', e.target.value)}
                          />
                        </Col>

                        <Col md="2 mb-2">
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Search Order ID..."
                            value={filter.razorpay_order_id}
                            onChange={(e) => handleFilterChange('razorpay_order_id', e.target.value)}
                          />
                        </Col>

                        <Col md="2 mb-2">
                          <Input
                            type="select"
                            className="form-control"
                            value={dateField}
                            onChange={(e) => setDateField(e.target.value)}
                          >
                            <option value=""> == Date Field == </option>
                            <option value="checkInDateTime">Check-In Date</option>
                            <option value="checkOutDateTime">Check-Out Date</option>
                            <option value="createdAt">Booking Date</option>
                          </Input>
                        </Col>

                        <Col md="4 mb-2">
                          <RangePicker
                            className="w-100"
                            value={dateRange}
                            onChange={(values) => handleRangeChange(values)}
                            placeholder={['Start Date', 'End Date']}
                          />
                        </Col>

                        <Col md="2 mb-2" className="d-flex align-items-center gap-2">
                          <Button color="secondary" onClick={ClearAllhandler}>
                            Clear All
                          </Button>
                          <Tooltip title="Export CSV">
                            <IconButton
                              onClick={handleDownloadCSV}
                              className="p-2"
                              style={{ border: '1px solid #ced4da', borderRadius: '4px', backgroundColor: '#f8f9fa' }}
                            >
                              <Download size={18} color="green" />
                            </IconButton>
                          </Tooltip>
                        </Col>
                      </Row>
                    </th>
                  </tr>
                </thead>
              </Table>

              <Box
                sx={{
                  '& .even': { backgroundColor: '#f1f1f1' },
                  '& .odd': { backgroundColor: 'white' }
                }}
              >
                {responseLoader ? (
                  <TableSkeleton />
                ) : formvalue?.length ? (
                  <DataGrid
                    sx={MuiTabelStyle}
                    autoHeight
                    pagination
                    rows={formvalue}
                    rowCount={record}
                    pageSize={pageSize}
                    getRowId={(row) => row.razorpay_order_id || row.createdAt}
                    columns={defaultColumns}
                    page={page - 1}
                    rowsPerPageOptions={[7, 10, 25, 50]}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                    paginationMode="server"
                    disableSelectionOnClick
                    sortingMode="server"
                    onSortModelChange={sorting}
                    getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
                  />
                ) : (
                  <DataNotFound />
                )}
              </Box>
            </Card>
          </Col>
        </Row>
      </Container>

      <GenerateBookingLinkModal
        isOpen={openInviteModal}
        toggle={() => setOpenInviteModal(!openInviteModal)}
      />
    </Fragment>
  );
};

export default AccommodationBookingList;
